define('views/modules/attachment/attachment-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/fetch-list',
    'views/modules/attachment/attachment-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFetchList,
    VAttachmentListItem
) {

    var VAttachmentList = VFetchList.extend({
        item: VAttachmentListItem,

        initialize: function(options) {
            this.collection = options.collection
        },

    });

    return VAttachmentList;
});

